import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-manual-email-table",
	templateUrl: "./manual-email-table.component.html",
	styleUrls: ["./manual-email-table.component.css"],
})
export class ManualEmailTableComponent implements OnInit {
	constructor(private confirmationService: ConfirmationService) {}

	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() SendEmail: EventEmitter<any> = new EventEmitter();
	@Output() RemovePerson: EventEmitter<any> = new EventEmitter();
	@Output() RemoveAll: EventEmitter<any> = new EventEmitter();
	@Input() Processing: boolean = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	@Input() lstPerson: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSendEmail() {
		this.SendEmail.emit(this.lstPerson);
	}

	ClearData() {
		this.lstPerson = [];
		this.SelectedPerson = null;
	}

	onRemove(Person) {
		this.onRowUnselect(null);
		this.RemovePerson.emit(Person);
	}

	onClearAll() {
		if (this.lstPerson.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "emailconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Clearing the email table will get rid of any changes you have made. Are you sure you want to continue?.",
			header: "Confirm Remove All",
			icon: "fa",
			accept: () => {
				this.onFinishClear();
			},
		});
	}

	onFinishClear() {
		this.onRowUnselect(null);
		this.RemoveAll.emit(true);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
